module.exports = __webpack_public_path__ + "img/headphone-1.4e7138d4.jpg";